module.exports = __webpack_public_path__ + "static/media/33622.464c2d6c.svg";